import SubtitleLoader from './lib/components/subtitles/SubtitleLoader.svelte';
import SubtitlePanel from './lib/components/subtitles/SubtitlePanel.svelte';

import { mount } from 'svelte';

mount(SubtitlePanel, {
    target: document.getElementById('addfromurl')
});

mount(SubtitleLoader, {
    target: document.getElementById('addfromurl')
});
